export const ACTIONS = {
  SET_SESSION: 'SESSION__SET_SESSION',
  CLEAR_SESSION: 'SESSION__CLEAR_SESSION',
};